export enum SearchEvent {
  TOGGLE_SEARCH = 'ToggleSearch',
  SEARCH = 'SearchQuery',
}
